module.exports = __webpack_public_path__ + "static/img/cjjj.c4a8b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cjjj.png
// module id = iT+k
// module chunks = 1